import { ADD_ANNOUNCEMENT, DELETE_ANNOUNCEMENT, GET_ANNOUNCEMENT_DETAILS, GET_ANNOUNCEMENT_LIST, UPDATE_ANNOUNCEMENT } from "../../constants";

export function getAnnouncementList(data) {
    return {
        type: GET_ANNOUNCEMENT_LIST,
        data,
    };
}

export function getAnnouncementDetails(data) {
    return {
        type: GET_ANNOUNCEMENT_DETAILS,
        data,
    };
}


export function addAnnouncement(data) {
    return {
        type: ADD_ANNOUNCEMENT,
        data,
    };
}


export function updateAnnouncement(data) {
    return {
        type: UPDATE_ANNOUNCEMENT,
        data,
    };
}

export function deleteAnnouncement(data) {
    return {
        type: DELETE_ANNOUNCEMENT,
        data,
    };
}
